import { forwardRef, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatInputModule } from "@angular/material/input";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { GenericDatepickerComponent } from "./generic-datepicker.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDateMaskDirective } from "../directive/mat-date-mask.directive";

@NgModule({
  declarations: [GenericDatepickerComponent, MatDateMaskDirective],
  imports: [CommonModule, MatFormFieldModule, MatAutocompleteModule, MatInputModule, ReactiveFormsModule, MatDatepickerModule],
  exports: [GenericDatepickerComponent],
})
export class GenericDatePickerModule {}
